module.exports = "/static/assets/ce4b7756c3d8b5c5e32aa1a0c93d22a5.png";